import Id from "../types/Id";
import SuperJSON from "superjson";

export default class FieldId extends Id<"field"> {}

SuperJSON.registerClass(FieldId, { identifier: "FieldId" });
